<template>
    <div class="col-md-7">
        <h2>Delivery Information</h2>

        <div class="form-group">
            <input type="text" class="form-control" placeholder="" v-model="localShipping.first_name" aria-describedby="first name" name="first_name"
                   :class="{'is-invalid': hasError('shipping.first_name')}">
            <small class="form-text text-muted">First Name*</small>
            <div class="invalid-feedback">
                The first name field is required.
            </div>
        </div>

        <div class="form-group">
            <input type="email" class="form-control" placeholder="" v-model="localShipping.last_name" aria-describedby="last name" name="last_name"
                   :class="{'is-invalid': hasError('shipping.last_name')}">
            <small class="form-text text-muted">Last Name*</small>
            <div class="invalid-feedback">
                The last name field is required.
            </div>
        </div>

        <div class="form-group">

            <input type="email" class="form-control" placeholder="" v-model="localShipping.email_address" aria-describedby="email address" name="email_address"
                   :class="{'is-invalid': hasError('shipping.email_address')}" @blur="emailChanged">
            <small class="form-text text-muted">Email Address*</small>
            <div class="invalid-feedback">
                The email address field is required and must be a valid email.
            </div>

        </div>

        <div class="form-group">

            <input type="tel" class="form-control" placeholder="" v-model="localShipping.phone_number" aria-describedby="phone_number" name="phone_number"
                   :class="{'is-invalid': hasError('shipping.phone_number')}">
            <small class="form-text text-muted">Cell Phone Number*</small>
             <p class="phonedisclaimer">by entering your phone number, you agree to receive multiple texts related to the status of your Rent One order. you may opt out anytime by replying STOP to the message. Data rates may apply.</p>
            <div class="invalid-feedback">
                The phone number field is required.
            </div>

        </div>

        <div class="form-group">

            <input type="tel" class="form-control" placeholder="" v-model="localShipping.birthday" aria-describedby="birthday" name="birthday"
                   :class="{'is-invalid': hasError('shipping.birthday')}">
            <small class="form-text text-muted">Birthday*</small>
            <div class="invalid-feedback">
                The birthday field is required.
            </div>

        </div>

        <div class="form-group">

            <input type="text" class="form-control" placeholder="" v-model="localShipping.street" aria-describedby="address" name="address"
                   :class="{'is-invalid': hasError('shipping.street')}">
            <small class="form-text text-muted">Address*</small>
            <div class="invalid-feedback">
                The address field is required.
            </div>

        </div>

        <div class="form-group">
            <input type="city" class="form-control" aria-describedby="city" placeholder="" v-model="localShipping.city" name="city"
                   :class="{'is-invalid': hasError('shipping.city')}">
            <small class="form-text text-muted">City*</small>
            <div class="invalid-feedback">
                The city field is required.
            </div>
        </div>

        <div class="form-group">
            <select class="form-control" v-model="localShipping.state" aria-describedby="state" name="state"
                    :class="{'is-invalid': hasError('shipping.state')}">
                <option v-for="state in states">{{ state }}</option>
            </select>
            <small class="form-text text-muted">State*</small>
            <div class="invalid-feedback">
                The state field is required.
            </div>
        </div>

        <!--
            <div class="col-md-6">
                <div class="form-group">
                    <label class="form-text" for="zipcode">Zipcode*</label>
                    <input
                        type="text"
                        class="form-control"
                        aria-describedby="zipcode"
                        placeholder=""
                        v-model="localShipping.zipcode"
                        @blur="zipcodeChanged"
                        name="zipcode"
                        id="zipcode"
                        autocomplete="postal-code"
                        :class="{'is-invalid': hasError('shipping.zipcode')}">
                    <div class="invalid-feedback">
                        <span v-if="errors['shipping.zipcode']" v-html="errors['shipping.zipcode'][0]"></span>
                        <span v-if="!errors['shipping.zipcode']">The zipcode field is required.</span>
                    </div>
                </div>
            </div>
        -->

        <div class="form-group">
            <input
                type="number"
                class="form-control zipcode-input"
                aria-describedby="zipcode"
                placeholder=""
                v-model="localShipping.zipcode"
                @blur="zipcodeChanged"
                name="zipcode"
                :class="{'is-invalid': hasError('shipping.zipcode')}">
            <small class="form-text text-muted">Zipcode*</small>
            <div class="invalid-feedback">
                <span v-if="errors['shipping.zipcode']" v-html="errors['shipping.zipcode'][0]"></span>
                <span v-if="!errors['shipping.zipcode']">The zipcode field is required.</span>
                <!-- The zipcode field is required. -->
            </div>
        </div>

        <div v-if="stores" class="form-group store-selector">
            <select class="form-control"
                    v-model="localStore"
                    aria-describedby="store"
                    name="store"
                    @change="storeChanged"
                    :class="{'is-invalid': localStore === null}">
                <option :value="null">Select a Store</option>
                <option v-for="(store, i) in stores" :key="i" :value="store">{{ `${store.name} (${store.address})` }}</option>
            </select>
            <small class="form-text text-muted">Store*</small>
            <div class="invalid-feedback">
                The store field is required.
            </div>
        </div>


        <h2>Billing Address</h2>
        <div class="form-check">
            <input class="form-check-input" type="checkbox" id="sameas" v-model="localSameas">
            <label class="form-check-label" for="sameas">
                Same as Delivery
            </label>
        </div>
        <div v-show="!sameas">
            <div class="form-group">
                <input type="text" class="form-control" placeholder="" v-model="localBilling.first_name" aria-describedby="first name" name="first_name"
                       :class="{'is-invalid': hasError('billing.first_name')}">
                <small class="form-text text-muted">First Name*</small>
                <div class="invalid-feedback">
                    The first name field is required.
                </div>
            </div>

            <div class="form-group">
                <input type="email" class="form-control" placeholder="" v-model="localBilling.last_name" aria-describedby="last name" name="last_name"
                       :class="{'is-invalid': hasError('billing.last_name')}">
                <small class="form-text text-muted">Last Name*</small>
                <div class="invalid-feedback">
                    The last name field is required.
                </div>
            </div>

            <div class="form-group">
                <input type="text" class="form-control" placeholder="" v-model="localBilling.street" aria-describedby="address" name="address"
                       :class="{'is-invalid': hasError('billing.street')}">
                <small class="form-text text-muted">Address*</small>
                <div class="invalid-feedback">
                    The address field is required.
                </div>
            </div>

            <div class="form-group">
                <input type="city" class="form-control" aria-describedby="city" placeholder="" v-model="localBilling.city" name="city"
                       :class="{'is-invalid': hasError('billing.city')}">
                <small class="form-text text-muted">City*</small>
                <div class="invalid-feedback">
                    The city field is required.
                </div>
            </div>

            <div class="form-group">
                <select class="form-control" v-model="localBilling.state" aria-describedby="state" name="state"
                        :class="{'is-invalid': hasError('billing.state')}">
                    <option v-for="state in states">{{ state }}</option>
                </select>
                <small class="form-text text-muted">State*</small>
                <div class="invalid-feedback">
                    The state field is required.
                </div>
            </div>

            <div class="form-group">
                <input
                    type="number"
                    class="form-control zipcode-input"
                    aria-describedby="zipcode"
                    placeholder=""
                    v-model="localBilling.zipcode"
                    name="zipcode"
                    :class="{'is-invalid': hasError('billing.zipcode')}">
                <small class="form-text text-muted">Zipcode*</small>
                <div class="invalid-feedback">
                    The zipcode field is required.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CheckoutPricing from "./CheckoutPricing.vue";
    import Order from "./Order.vue";
    import Inquiry from "./Inquiry.vue";
    import Location from "./Location.vue";

    import { ServiceFactory } from "../../../../../../shared/assets/js/services/ServiceFactory";
    const PricingService = ServiceFactory.get("pricing");
    const OrderService = ServiceFactory.get("order");
    const CartService = ServiceFactory.get("cart");
    const ActOnEmailCapture = ServiceFactory.get("actOnEmailCapture");
    const PromoService = ServiceFactory.get("promos");
    const StoreLookupService = ServiceFactory.get("storeLookup");

    export default {
        props: ['states', 'shipping', 'billing', 'sameas', 'errors', 'stores'],

        data() {
            return {
                localShipping: {},
                localBilling: {},
                localSameas: false,
                localStore: null,
            }
        },

        created() {
            this.localShipping = this.shipping;
            this.localBilling = this.billing;
            this.localSameas = this.sameas;
        },


        watch: {
            localShipping() {
                this.syncToParent()
            },
            localBilling() {
                this.syncToParent()
            },
            localSameas() {
                this.syncToParent()
            },
        },


        methods: {
            syncToParent() {
                this.$emit('data-changed', {shipping: this.localShipping, billing: this.localBilling, sameas: this.localSameas});
            },

            emailChanged() {
                this.$emit('email-changed', this.localShipping.email_address);
            },

            zipcodeChanged() {
                this.localStore = null;
                this.storeChanged();
                this.$emit('zipcode-changed', this.localShipping.zipcode);
            },

            storeChanged() {
                this.$emit('store-changed', this.localStore);
            },

            hasError(field) {
                if (this.errors[field]) {
                    return true;
                }

                return false;
            }
        }
    }
</script>
